import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgDexpanthenolGlyphSecondary from './svgs/DexpanthenolGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var dexpanthenolGlyph = (props => useIcon(null, SvgDexpanthenolGlyphSecondary, props));

export { dexpanthenolGlyph as default };
